import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { clawbackMainRoute } from '..';

export const clawbackDetailRoute = createRoute({
  getParentRoute: () => clawbackMainRoute,
  path: '$requestId',
  component: lazyRouteComponent(() => import('./ClawbackDetailView')),
  parseParams: (params) => ({
    requestId: z.string().parse(params.requestId),
  }),
  validateSearch: z.object({
    clawbackDetailQ: z.string().optional(),
    reasons: z.array(z.string()).optional(),
  }).parse,
});
